/**
 * Value of the `add_to_cart_source` parameter sent to GA4 and Jentis.
 *
 * The type can be string because some sources are built at runtime: the ax drawer
 * builds `drawer_${productName}` (see `getAxDrawerEventName`) and domain search
 * uses values from `DomainSearchEvent`.
 */
export type AddToCartSourceValue = BasketActionSource | string

export enum BasketActionSource {
  EMPTY = "",
  BASKET = "basket",
  SUMMARY = "summary",
  QUICK = "quick",
  BONUS = "bonus",
  TRANSFER = "transfer",
  PARAMETERS = "parameters",
  DOMAINS = "domains",
  GENERIC_PAGE = "generic-page",
  PMAILS = "pmails",
  MODAL = "modal",
  CONFIG_DRAWER = "config-drawer",
  DOMAIN_EMAIL_HOOK = "domain_email_hook",
  DOMAIN_EMAIL_HOOK_BASKET = "domain_email_hook_basket",
  BASKET_UPSELL_BOX = "basket_upsell_box",
}

export enum BasketActions {
  BASKET = "BASKET.ACTIONS.BASKET",
  BASKET_PREPARE_FOR_SUMMARY = "BASKET.ACTIONS.BASKET_PREPARE_FOR_SUMMARY",
  BASKET_ERROR = "BASKET.ACTIONS.BASKET_ERROR",
  BASKET_SUCCESS = "BASKET.ACTIONS.BASKET_SUCCESS",
  BASKET_PROMO_CODE_ERROR = "BASKET_PROMO_CODE_ERROR",
  BASKET_RESET_BUTTON = "BASKET.ACTIONS.BASKET_RESET_BUTTON",
  BASKET_ITEM_REMOVED = "BASKET.ACTIONS.BASKET_ITEM_REMOVED",
  BASKET_CHANGE_PAYMENT = "BASKET.ACTIONS.BASKET_CHANGE_PAYMENT",
  REMOVE_ITEM_CONFIRM_MODAL_SHOW = "REMOVE_ITEM_CONFIRM_MODAL_SHOW",
  REMOVE_ITEM_CONFIRM_MODAL_CLOSE = "REMOVE_ITEM_CONFIRM_MODAL_CLOSE",
  REMOVE_ITEM_WITH_CONFIRMATION = "REMOVE_ITEM_WITH_CONFIRMATION",
  MANUAL_DOMAIN_HOOK_ADD = "MANUAL_DOMAIN_HOOK_ADD",
  BASKET_ADD_PROMO_CODE = "BASKET.ACTIONS.ADD_PROMO_CODE",
  BASKET_REMOVE_PROMO_CODE = "BASKET.ACTIONS.REMOVE_PROMO_CODE",
  BASKET_CHANGE_TERM = "BASKET.ACTIONS.BASKET_CHANGE_TERM",
  BASKET_CHANGE_QUANTITY = "BASKET.ACTIONS.BASKET_CHANGE_QUANTITY",
  PLAN_OVER_LIMIT_MODAL_SHOW = "PLAN_OVER_LIMIT_MODAL_SHOW",
  PLAN_OVER_LIMIT_MODAL_CLOSE = "PLAN_OVER_LIMIT_MODAL_CLOSE",
}

export const BASKET_STATUS = {
  NONE: "none",
  PENDING: "pending",
  HAS_USER_DATA: "has_user_data",
  ACTIVE: "active",
  ARCHIVED: "archived",
  ASSIGNED: "assigned",
}
